import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Flame, Percent } from "lucide-react";

export default function Campaigns() {
  const { t } = useApp();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/products");
      setProducts(data);
    })();
  }, []);

  const weekly = products.filter((p) => p.is_weekly_deal);
  const campaigns = products.filter((p) => p.is_campaign);

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex flex-col">
      <Header />
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-10">
        <div className="mb-8">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#D9653B]/10 border border-[#D9653B]/30 text-[#D9653B] font-heading font-bold text-sm mb-3">
            <Flame className="w-4 h-4" />
            SICAK FIRSATLAR
          </div>
          <h1 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-[#1B2A22]">
            {t("campaigns_title")}
          </h1>
        </div>

        <Tabs defaultValue="weekly">
          <TabsList className="bg-white border border-[#E8E2D5] rounded-full p-1 mb-6">
            <TabsTrigger
              value="weekly"
              data-testid="tab-weekly"
              className="data-[state=active]:bg-[#E5A024] data-[state=active]:text-white rounded-full font-heading font-semibold"
            >
              🔥 {t("weekly_deals")}
            </TabsTrigger>
            <TabsTrigger
              value="all"
              data-testid="tab-all-campaigns"
              className="data-[state=active]:bg-[#D9653B] data-[state=active]:text-white rounded-full font-heading font-semibold"
            >
              <Percent className="w-4 h-4 mr-1" /> {t("campaigns")}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="weekly">
            {weekly.length === 0 ? (
              <p className="text-[#1B2A22]/60 text-center py-12">
                Şu an haftalık kampanya yok.
              </p>
            ) : (
              <div
                data-testid="weekly-grid"
                className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4"
              >
                {weekly.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            )}
          </TabsContent>

          <TabsContent value="all">
            {campaigns.length === 0 ? (
              <p className="text-[#1B2A22]/60 text-center py-12">
                Şu an aktif kampanya yok.
              </p>
            ) : (
              <div
                data-testid="campaigns-grid"
                className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4"
              >
                {campaigns.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            )}
          </TabsContent>
        </Tabs>
      </main>
      <Footer />
    </div>
  );
}
